module.exports = __webpack_public_path__ + "static/img/fu.2a728c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu.jpg
// module id = v86r
// module chunks = 1